import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedModule } from '../../../core/shared.module';
import { FiltroService } from '../../../service/filtro.service';
import { AppService } from '../../../service/app.service';
import { Utente } from '../../../interfaces/user';
import { tipologicaInterface } from '../../../interfaces/tipologica.interface';
import { Attori } from '../../enum/attori.enum';
import { DateConversionService } from '../../utilities/dateconversion.service';

@Component({
  selector: 'app-filtro-elenco-risorse',
  standalone: true,
  templateUrl: './filtro-elenco-risorse.component.html',
  imports: [SharedModule],
})
export class FiltroElencoRisorseComponent {
  form: FormGroup;
  @Input() uoPrimoLivello: tipologicaInterface[] = [];
  @Input() attore: number = 0;
  @Output() searchEvent = new EventEmitter();
  utente: Utente = this.appService.user;
  attori = Attori;

  constructor(
    private fb: FormBuilder,
    private filtroService: FiltroService,
    private appService: AppService,
    private dateConversionService: DateConversionService,
  ) {
    this.form = this.fb.group({
      risorsa: [''],
      nomeRisorsa: [''],
      nomeResponsabile: [''],
      descrizioneUnitaOrganizzativaPrimoLivello: [''],
      descrizioneUnitaOrganizzativa: [''],
      modificato: [null],
      approvato: [null],
      nomeDelegante: [null],
      nomeApprovatore: [''],
      dataApprovazione: [''],
    });
  }

  ngOnInit(): void {
    this.filtroService.ultimoFiltroElencoRisorse(this.attore).subscribe((filtro) => {
      this.form.patchValue({ ...filtro });
      if (filtro.dataApprovazione)
        this.form
          .get('dataApprovazione')
          ?.patchValue(
            this.dateConversionService.convertDateToISO(
              filtro.dataApprovazione
            ),
            { emitEvent: false }
          );
    });
  }

  search(reset?: boolean): void {
    if (reset) {
      this.form.reset();
    }

    const retValue = { ...this.form.value };

    if (retValue.dataApprovazione) {
      retValue.dataApprovazione =
        this.dateConversionService.convertDateToDDMMYYYY(
          retValue.dataApprovazione
        );
    }

    this.filtroService.setUltimoFiltroElencoRisorse(retValue, this.attore);
    this.searchEvent.emit(retValue);
  }

}
